import { Router, ScreenBase, watchBusy } from "@frui.ts/screens";
import ReportRepository from "repositories/reportRepository";
import LocalizationService from "services/localizationService";
import { computed, observable } from "mobx";
import { bound } from "@frui.ts/helpers";
import download from "downloadjs";
import fileNameWithDate from "../../../utils/fileNameWithDate";
import { Modules, startOfEDAZ } from "../../../config";
import BusyWatcher from "@frui.ts/screens/dist/structure/busyWatcher";
import { AxiosResponse } from "axios";
import parseFileNameFromAxiosResponse from "../../../utils/parseFileNameFromAxiosResponse";

const navigationName = "unreturned-refunds-of-refunds";

@Router.registerRoute({ name: Router.Self, route: navigationName })
export default class UnreturnedRefundOfRefundsViewModel extends ScreenBase {
  @observable busyWatcher = new BusyWatcher();
  @observable fileResponse: AxiosResponse;

  constructor(private localizationService: LocalizationService, private repository: ReportRepository) {
    super();
    this.navigationName = navigationName;
  }

  @computed
  get name() {
    return this.translate("name");
  }

  @bound
  @watchBusy
  async onDownloadClick() {
    this.fileResponse = await this.repository.unreturnedRefundsOfRefunds(startOfEDAZ, new Date());
    download(
      this.fileResponse.data,
      parseFileNameFromAxiosResponse(this.fileResponse, fileNameWithDate("nevracene_vratky_na_vratku", "xlsx", new Date())),
      this.fileResponse.headers["content-type"] ?? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  }

  translate(code: string) {
    return this.localizationService.translateModule(Modules.finance, `unreturnedRefundOfRefunds.${code}`);
  }
}
